import { cn } from "../../lib/utils";
import { PageNavigationContext } from "./PageNavigation";
import "./page-title.css";

/** Keep the Back control with its page heading, including inside form layouts. */
export function PageTitleRow({ back, children, className }) {
  return (
    <PageNavigationContext.Provider value={undefined}>
      <div className={cn("page-title-row", className)}>
        {back ? <div className="page-title-row__back">{back}</div> : null}
        <div className="page-title-row__title">{children}</div>
      </div>
    </PageNavigationContext.Provider>
  );
}